import { memo } from 'react';
import type { FC, ReactNode } from 'react';

import resets from '../../../_resets.module.css';
import classes from './Pagetop.module.css';
import { PolygonIcon }  from './PolygonIcon';

interface Props {
  className?: string;
  classes?: {
    root?: string;
  };
  swap?: {
    polygon?: ReactNode;
  };
}
/* @figmaId 737:588 */
export const Pagetop: FC<Props> = memo(function Pagetop(props = {}) {

  const scrollToTop = () => {
    window.scrollTo({
        top: 0,
        behavior: "smooth"  // スムーズスクロール
    });
};
  return (
    <div className={`${resets.clapyResets} ${props.classes?.root || ''} ${props.className || ''} ${classes.root}`}>
       <div className={classes.polygon}>{props.swap?.polygon || <PolygonIcon className={classes.icon} />}</div>
      <div className={classes.pageTop} onClick={scrollToTop}>Page Top</div>
    </div>
  );
});
